import {jsonMember, jsonObject} from "typedjson";
import {DxGridToolbarAction} from "./dx-grid-toolbar-action";


/** Опции кнопки панели иснтрументов списка. */
@jsonObject
export class DxGridToolbarButton {

  @jsonMember({name: "title", constructor: String, emitDefaultValue: false, isRequired: false})
  private _title: string;

  @jsonMember({name: "icon", constructor: String, emitDefaultValue: false, isRequired: false})
  private _icon: string;

  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false})
  private _ord: number = 1;

  @jsonMember({name: "disabled", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _disabled: boolean = true;

  @jsonMember({name: "action", constructor: DxGridToolbarAction, emitDefaultValue: false, isRequired: false})
  private _action: DxGridToolbarAction;

  get action(): DxGridToolbarAction {
    return this._action;
  }

  set action(value: DxGridToolbarAction) {
    this._action = value;
  }

  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(value: string) {
    this._icon = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = value;
  }

  constructor(fields?: Partial<DxGridToolbarButton>) {
    if (fields) {
      Object.assign(this, fields);
    }
  }
}
